module.exports = __webpack_public_path__ + "static/forecast/weather/nightthunderstorm-96628cdb8e951d981434a4c37ac1951b.svg";